import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
// import { DiscordIcon, Logo, TwitterIcon, YoutubeIcon } from "../../../assets/svgIcons/svgIcons";
import './Footer.scss';
const Footer = () => {
    return (
        <footer className="footer">
            <Container fluid>
                <Row className="align-items-center">
                    <Col xs={12}>
                        <p>© Stronghodl. All rights reserved. </p>
                        <div className="footer_links">
                            <Link to="#">Terms and Conditions</Link> <span>|</span> <Link to="#">Privacy Policy</Link>
                        </div>
                        </Col>
                </Row>
            </Container>
        </footer>
    )
}
export default Footer